import React from 'react';
import { Table, Text, mergeClassNames, EmptyState } from '@clockout-dev/design-elements';
import TransactionTypePill from './TransactionTypePill';
import TransactionStatusPill from './TransactionStatusPill';
import { formatFullCurrency } from '../../../utils/numbers';
import styles from './styles/transactionsTable.module.scss';

/**
 * Pure presentational table for the Transaction History section. The
 * orchestrator controls pagination via the `pageInfo` prop
 * (`{ current, perPage, total }`) — that's the shape the package Table
 * uses to derive its footer pager. Rows are REPLACED on every page
 * change (no append).
 *
 * Columns track the Figma design: ID, Created Date, Processed Date,
 * Type, Account, Status, Amount, Full Name, SSN.
 */
function TransactionsTable({ rows, loading, pageInfo, onChange }) {
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (text) => (
                <Text as="span" size="xs" className={styles.idCell}>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Created Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (value) => (
                <Text as="span" size="xs" className={styles.idCell}>
                    {value}
                </Text>
            ),
        },
        {
            title: 'Processed Date',
            dataIndex: 'processedDate',
            key: 'processedDate',
            render: (value) => (
                <Text as="span" size="xs" className={styles.idCell}>
                    {value}
                </Text>
            ),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (value) => <TransactionTypePill type={value} />,
        },
        {
            title: 'Account',
            dataIndex: 'account',
            key: 'account',
            render: (value) => (
                <Text as="span" size="xs" className={styles.idCell}>
                    {value}
                </Text>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (value) => <TransactionStatusPill status={value} />,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            width: 110,
            render: (value) => (
                <Text as="span" size="xs" className={mergeClassNames([styles.amountCell, styles.idCell])}>
                    {formatFullCurrency(value)}
                </Text>
            ),
        },
        {
            title: 'Full Name',
            dataIndex: 'fullName',
            key: 'fullName',
            render: (value) => (
                <Text as="span" size="xs" className={styles.idCell}>
                    {value}
                </Text>
            ),
        },
        {
            title: 'SSN',
            dataIndex: 'last4Ssn',
            key: 'last4Ssn',
            render: (value) => (
                <Text as="span" size="xs" className={mergeClassNames([styles.idCell, styles.ssnCell])}>
                    ***{value}
                </Text>
            ),
        },
    ];

    return (
        <Table
            dataSource={rows}
            columns={columns}
            loading={loading}
            rowKey="id"
            pageInfo={pageInfo}
            saveSearchParams
            onChange={onChange}
            emptyState={<EmptyState title="No transactions found." />}
            classNames={{
                shell: styles.tableWrapper,
                root: styles.table,
            }}
        />
    );
}

export default TransactionsTable;
